import React from 'react';
import { useTranslation } from 'react-i18next';
import { NS } from '../U3204';
import { useU3204Context } from '../U3204Context';
import U3204MissionModelFooter from './U3204MissionModelFooter';
import U3204TokenUsageSummary from './U3204TokenUsageSummary';

interface U3204ChatComposerFooterProps {
  hideMissionModel?: boolean;
  hideTokenSummary?: boolean;
}

const U3204ChatComposerFooter: React.FC<U3204ChatComposerFooterProps> = ({
  hideMissionModel = false,
  hideTokenSummary = false,
}) => {
  const { t } = useTranslation(NS);
  const { activeConversationId, activeMission, activeDefaultModel, canAttachFiles, messages } = useU3204Context();

  const showAttachUnavailableHint =
    Boolean(activeConversationId) && Boolean(activeMission) && activeDefaultModel === null;

  return (
    <div className="mt-2 flex gap-2">
      {canAttachFiles ? <div className="w-10 shrink-0" aria-hidden="true" /> : null}
      <div className="flex min-h-5 min-w-0 flex-1 flex-col gap-1">
        <div
          className={`flex min-w-0 flex-wrap items-center gap-x-3 gap-y-1.5 ${
            hideMissionModel && hideTokenSummary
              ? 'hidden'
              : hideMissionModel
                ? 'justify-end'
                : 'justify-between'
          }`}
        >
          {hideMissionModel ? null : <U3204MissionModelFooter />}
          {hideTokenSummary ? null : <U3204TokenUsageSummary messages={messages} />}
        </div>
        {showAttachUnavailableHint ? (
          <p className="text-xs text-muted-foreground" title={t('attachModelNotConfigured', { ns: NS })}>
            {t('attachModelNotConfigured', { ns: NS })}
          </p>
        ) : null}
      </div>
      <div className="w-10 shrink-0" aria-hidden="true" />
    </div>
  );
};

export default U3204ChatComposerFooter;
